import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Modal, ModalBody, Form, FormGroup } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import { Icon } from "../../../../components/Component";
import { servicePutLeadReceptionStatus } from "services/users";

const REASON_PATTERN = /^[a-zA-Z0-9 ]+$/;

const LeadReceptionModal = ({ isOpen, onClose, token, onSuccess }) => {
  const { register, handleSubmit, errors, reset } = useForm();
  const [resumeAt, setResumeAt] = useState(null);
  const [resumeAtError, setResumeAtError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const closeModal = () => {
    reset();
    setResumeAt(null);
    setResumeAtError("");
    onClose();
  };

  const onSubmit = async (formValues) => {
    if (!resumeAt) {
      setResumeAtError("Resume time is required");
      return;
    }
    if (resumeAt < new Date()) {
      setResumeAtError("Resume time cannot be before the current time");
      return;
    }
    setResumeAtError("");

    setSubmitting(true);
    const payload = {
      active: false,
      reason: formValues.reason.trim(),
      resumeAt: moment(resumeAt).seconds(0).milliseconds(0).utc().format(),
    };

    const response = await servicePutLeadReceptionStatus(token, payload);
    setSubmitting(false);

    if (response?.status >= 200 && response?.status < 300) {
      Swal.fire("Lead Acceptable", "Status updated successfully", "success");
      onSuccess({
        updatedAt: response.data?.leadReceptionUpdatedAt,
        reason: payload.reason,
        resumeAt: payload.resumeAt,
      });
      closeModal();
    } else {
      Swal.fire("Lead Acceptable", "Failed to update status, please try again", "error");
    }
  };

  return (
    <Modal isOpen={isOpen} backdrop="static" keyboard={false} toggle={closeModal} className="modal-dialog-centered">
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Pause New Leads</h5>
          <div className="mt-4">
            <Form className="row gy-4" onSubmit={handleSubmit(onSubmit)}>
              <div className="col-12">
                <FormGroup>
                  <label className="form-label">Reason</label>
                  <textarea
                    className="form-control"
                    name="reason"
                    rows="3"
                    placeholder="e.g. taking a break"
                    ref={register({
                      required: "Reason is required",
                      pattern: {
                        value: REASON_PATTERN,
                        message: "Reason can only contain letters, numbers, and spaces",
                      },
                    })}
                  ></textarea>
                  {errors.reason && <span className="custom-invalid">{errors.reason.message}</span>}
                </FormGroup>
              </div>
              <div className="col-12">
                <FormGroup>
                  <label className="form-label">Resume At</label>
                  <DatePicker
                    selected={resumeAt}
                    onChange={(date) => {
                      setResumeAt(date);
                      setResumeAtError("");
                    }}
                    showTimeSelect
                    timeIntervals={1}
                    timeFormat="HH:mm"
                    dateFormat="dd/MM/yyyy HH:mm"
                    minDate={new Date()}
                    placeholderText="Select date & time"
                    className="form-control date-picker"
                    autoComplete="off"
                  />
                  {resumeAtError && <span className="custom-invalid">{resumeAtError}</span>}
                </FormGroup>
              </div>
              <div className="col-12">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                      Save
                    </button>
                  </li>
                  <li>
                    <a
                      href="#cancel"
                      onClick={(ev) => {
                        ev.preventDefault();
                        closeModal();
                      }}
                      className="link link-light"
                    >
                      Cancel
                    </a>
                  </li>
                </ul>
              </div>
            </Form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LeadReceptionModal;
